// extracted by mini-css-extract-plugin
module.exports = {"titleText":"e_Eu","container":"e_Fu","authorText":"e_Gu","title":"e_Hu","image":"e_Iu","description":"e_Ju","author":"e_Ku","splitLine":"e_Lu"};